import { useState } from "react";
import { useCustom, useCustomMutation, useTranslate } from "@refinedev/core";
import { message } from "antd";

export const useOrderSettings = (apiUrl: string) => {
    const _t = useTranslate();

    const [settingsModalVisible, setSettingsModalVisible] = useState(false);
    const [settingsAutoStartOrder, setSettingsAutoStartOrder] = useState(false);

    const { data: mySettingsResponse, refetch: refetchMySettings } = useCustom<{
        data: Record<string, unknown> | null;
    }>({
        url: `${apiUrl}/users/my-settings`,
        method: "get",
    });

    const mySettings = mySettingsResponse?.data ?? null;
    const autoStartOrder =
        mySettings && typeof (mySettings as Record<string, unknown>).autoStartOrder === "boolean"
            ? (mySettings as Record<string, unknown>).autoStartOrder === true
            : false;

    const { mutate: updateMySettings, isLoading: isSavingSettings } = useCustomMutation();

    const handleOpenSettingsModal = () => {
        setSettingsAutoStartOrder(autoStartOrder);
        setSettingsModalVisible(true);
    };

    const handleSaveSettings = () => {
        updateMySettings(
            {
                url: `${apiUrl}/users/my-settings`,
                method: "patch",
                values: { autoStartOrder: settingsAutoStartOrder },
            },
            {
                onSuccess: () => {
                    refetchMySettings();
                    setSettingsModalVisible(false);
                    message.success(_t("orders.settings.saved"));
                },
                onError: () => {
                    message.error(_t("orders.settings.saveFailed"));
                },
            }
        );
    };

    return {
        autoStartOrder,
        settingsModalVisible,
        settingsAutoStartOrder,
        isSavingSettings,
        handleOpenSettingsModal,
        handleSaveSettings,
        setSettingsAutoStartOrder,
        setSettingsModalVisible,
    };
};
